import { useEffect, useState } from "react";
import { getWebsiteContent } from "../lib/database";
import { useAppIcon } from "../hooks/useAppIcon";

interface BrandLogoProps {
  src?: string;
  className?: string;
  markClassName?: string;
  /** full = horizontal studio logo when available; mark = 1:1 favicon/app icon */
  variant?: "full" | "mark";
}

function readHeaderLogo(row: unknown): string | null {
  const content = (row as { content?: { logo?: unknown } } | null)?.content;
  const logo = content?.logo;
  if (typeof logo === "string" && logo.trim()) return logo.trim();
  return null;
}

/**
 * Official brand images only.
 * - mark → resolved favicon / PWA app icon (1:1)
 * - full → uploaded header logo when present, otherwise the same app icon
 */
export function BrandLogo({ src, className, markClassName, variant = "full" }: BrandLogoProps) {
  const appIcon = useAppIcon();
  const [headerLogo, setHeaderLogo] = useState<string | null>(src || null);

  useEffect(() => {
    if (src) {
      setHeaderLogo(src);
      return;
    }
    if (variant === "mark") return;

    let cancelled = false;
    getWebsiteContent("header")
      .then((row) => {
        if (cancelled) return;
        setHeaderLogo(readHeaderLogo(row));
      })
      .catch(() => {
        if (!cancelled) setHeaderLogo(null);
      });

    return () => {
      cancelled = true;
    };
  }, [src, variant]);

  if (variant === "mark") {
    return (
      <img
        src={appIcon}
        alt="ON45D"
        className={markClassName || className || "h-8 w-8"}
        width={32}
        height={32}
      />
    );
  }

  if (headerLogo) {
    return <img src={headerLogo} alt="ON45D" className={className || "h-8 w-auto"} />;
  }

  return (
    <img
      src={appIcon}
      alt="ON45D"
      className={className?.includes("w-auto") ? className.replace(/\bw-auto\b/g, "w-10") : className || "h-10 w-10"}
      width={40}
      height={40}
    />
  );
}
